import {getEventCategory, getEventColor} from "@/common/utils/calendarHelpers";
import moment from "moment";

export default {
  state: {
    isLoadingCalendar: false,
    list: [],
    current: null,
    period: '',
    timedEvents: false
  },
  actions: {
    getEvents({commit, state}, params = '') {
      state.isLoadingCalendar = true;

      return axios.get(`/api/v1/student/calendar?${params}`)
        .then(response => {
          commit('SET_EVENTS', response.data.data);
          return response;
        })
        .finally(() => state.isLoadingCalendar = false);
    }
  },
  getters:{
    isLoadingCalendar: state => state.isLoadingCalendar,
    events: (state) => 
      state.list
      .map(e => {
        
        let now = moment();
        let eventDay = moment(e.start).format("DD");
        let current_day = now.format("DD")
        let is_today = current_day == eventDay
        return {
          name: e.title + ' : ' + e.description,
          start: new Date(e.start),
          end: new Date(e.end),
          is_today,
          type: e.type,
          title: e.title,
          description: e.description,
          date: e.start,
          dateTitle: is_today ? e.dateTitle = 'Hoje, ' + eventDay + ' de ' + now.locale('pt').format("MMMM") : moment(e.start).format("DD/MM/YYYY"), 
          category: getEventCategory(e),
          timed: e.timed === false && e.type === 'studying' ? true : state.timedEvents,
          color: getEventColor(e)
        }
      }),
      events_sorted_by_date_asc: (state, getters) => getters.events.sort((a,b) => moment(a.date) - moment(b.date)),
      cycle_events: (state, getters) => getters.cycles.map(c => {
        return {
          title: c.cycle_name,
          name: c.cycle_name,
          start: new Date(c.begin),
          end: new Date(c.end),
          type: "cycle",
          description: "",
          category: getEventCategory({type:"cycle"}),
          color: getEventColor({type: "cycle"})
        }
      }),
      eventsCycleTimed: (state,getters) => {
        return getters.events.map(e=>{
          e.timed = e.type !== 'cycle';
          return e;
        })
      }
  },
  mutations: {
    SET_EVENTS(state, payload) {
      state.list = payload;
    },
    SET_PERIOD(state, payload) {
      state.period = payload;
    }
  },
}
